export default function GettingStartedWelcomeComponent() {
  const cardsMap = [
    {
      name: "Creating a Test Plan",
      link: "/docs/test-plans/test-plan",
      icon: (
        <svg
          width="14"
          height="13"
          viewBox="0 0 14 13"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M12.0808 1.78207C11.9129 1.62738 11.7119 1.50699 11.4909 1.42864C11.2699 1.35028 11.0337 1.31569 10.7975 1.32707C10.3168 1.35183 9.86423 1.54548 9.53166 1.86873L5.51833 5.57373C5.49165 5.60096 5.46997 5.63207 5.45416 5.66582C5.43115 5.69637 5.41161 5.72904 5.39583 5.76332L4.66666 7.97332C4.64066 8.05583 4.63619 8.1429 4.65361 8.22734C4.67103 8.31178 4.70984 8.39115 4.76684 8.4589C4.82384 8.52664 4.89739 8.58082 4.9814 8.61695C5.06542 8.65307 5.15748 8.67011 5.24999 8.66665C5.3041 8.67456 5.35922 8.67456 5.41333 8.66665L7.74666 8.0329L7.85166 7.97873C7.88801 7.96405 7.92151 7.94392 7.95083 7.91915L11.9583 4.19248C12.3064 3.88367 12.515 3.46344 12.5417 3.01707C12.5644 2.79258 12.5351 2.56618 12.4556 2.35312C12.3761 2.14007 12.2483 1.94534 12.0808 1.78207Z"
            fill="#E9E9E9"
            stroke="black"
          />
          <path
            d="M11.6667 11.9166H2.33335C2.02393 11.9166 1.72719 11.8024 1.5084 11.5993C1.2896 11.3961 1.16669 11.1206 1.16669 10.8333V2.16659C1.16669 1.87927 1.2896 1.60372 1.5084 1.40055C1.72719 1.19739 2.02393 1.08325 2.33335 1.08325H7.00002C7.15473 1.08325 7.3031 1.14032 7.4125 1.2419C7.5219 1.34348 7.58335 1.48126 7.58335 1.62492C7.58335 1.76858 7.5219 1.90635 7.4125 2.00793C7.3031 2.10952 7.15473 2.16659 7.00002 2.16659H2.33335V10.8333H11.6667V6.49992C11.6667 6.35626 11.7281 6.21848 11.8375 6.1169C11.9469 6.01532 12.0953 5.95825 12.25 5.95825C12.4047 5.95825 12.5531 6.01532 12.6625 6.1169C12.7719 6.21848 12.8334 6.35626 12.8334 6.49992V10.8333C12.8334 11.1206 12.7104 11.3961 12.4916 11.5993C12.2729 11.8024 11.9761 11.9166 11.6667 11.9166Z"
            fill="#231F20"
          />
        </svg>
      ),
    },
    {
      name: "Merge Projects",
      link: "/docs/sharing-test-plans/merging-projects",
      icon: (
        <svg
          width="18"
          height="17"
          viewBox="0 0 30 30"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M11.4561 22.0631C11.1564 22.3428 10.9245 22.5301 10.6874 22.667C9.52718 23.3368 8.0977 23.3368 6.93745 22.667C6.50988 22.4201 6.0989 22.0091 5.27691 21.1872C4.45492 20.3652 4.04392 19.9542 3.79708 19.5266C3.12721 18.3663 3.12721 16.9368 3.79708 15.7766C4.04392 15.3491 4.45492 14.9381 5.27691 14.1161L8.81245 10.5806C9.63443 9.75859 10.0454 9.34759 10.473 9.10075C11.6332 8.43087 13.0627 8.43087 14.223 9.10074C14.6505 9.34759 15.0615 9.75859 15.8835 10.5806C16.7055 11.4026 17.1165 11.8135 17.3634 12.2411C18.0332 13.4013 18.0332 14.8308 17.3634 15.9911C17.2265 16.2281 17.0392 16.4601 16.7594 16.7597M13.2399 13.2402C12.96 13.5398 12.7727 13.7718 12.6359 14.0088C11.966 15.1691 11.966 16.5986 12.6359 17.7588C12.8827 18.1865 13.2937 18.5975 14.1157 19.4193C14.9377 20.2413 15.3487 20.6523 15.7762 20.8992C16.9365 21.5691 18.366 21.5691 19.5262 20.8992C19.9539 20.6523 20.3649 20.2413 21.1869 19.4193L24.7224 15.8838C25.5444 15.0618 25.9554 14.6508 26.2021 14.2233C26.872 13.0631 26.872 11.6336 26.2021 10.4733C25.9554 10.0458 25.5444 9.63479 24.7224 8.8128C23.9004 7.99081 23.4894 7.57982 23.0619 7.33297C21.9015 6.6631 20.4721 6.6631 19.3119 7.33297C19.0747 7.46982 18.8429 7.65711 18.5431 7.93691"
            stroke="black"
            stroke-width="2"
            stroke-linecap="round"
          />
        </svg>
      ),
    },
    {
      name: "Test Results and Analytics",
      link: "/docs/test-results-and-analytics/reviewing-test-results",
      icon: (
        <svg
          width="14"
          height="13"
          viewBox="0 0 14 13"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M5.4445 0V10.1093H8.55558V0H5.4445ZM7.70005 0.855402H6.30005V9.25391H7.70005V0.855402ZM0.777832 3.11055H3.88894V10.1093H0.777832V3.11055ZM1.63339 3.96596H3.03339V9.25391H1.63339V3.96596Z"
            fill="black"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M14 11.6646H0V12.5199H14V11.6646Z"
            fill="black"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M10.1111 4.66553H13.2221V10.109H10.1111V4.66553ZM10.9666 5.52093H12.3666V9.2536H10.9666V5.52093Z"
            fill="black"
          />
        </svg>
      ),
    },

    {
      name: "Sharing Test Plan",
      link: "/docs/sharing-test-plans/sharing-test-plans",
      icon: (
        <svg
          width="16"
          height="15"
          viewBox="0 0 16 15"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M5.99996 7.5C5.99996 8.36294 5.25377 9.0625 4.33329 9.0625C3.41282 9.0625 2.66663 8.36294 2.66663 7.5C2.66663 6.63706 3.41282 5.9375 4.33329 5.9375C5.25377 5.9375 5.99996 6.63706 5.99996 7.5Z"
            stroke="#1C274C"
            stroke-width="0.75"
          />
          <path
            d="M9.33333 4.0625L6 6.25"
            stroke="#1C274C"
            stroke-width="0.75"
            stroke-linecap="round"
          />
          <path
            d="M9.33333 10.9375L6 8.75"
            stroke="#1C274C"
            stroke-width="0.75"
            stroke-linecap="round"
          />
          <path
            d="M12.6667 11.5625C12.6667 12.4254 11.9205 13.125 11 13.125C10.0796 13.125 9.33337 12.4254 9.33337 11.5625C9.33337 10.6996 10.0796 10 11 10C11.9205 10 12.6667 10.6996 12.6667 11.5625Z"
            stroke="#1C274C"
            stroke-width="0.75"
          />
          <path
            d="M12.6667 3.4375C12.6667 4.30044 11.9205 5 11 5C10.0796 5 9.33337 4.30044 9.33337 3.4375C9.33337 2.57456 10.0796 1.875 11 1.875C11.9205 1.875 12.6667 2.57456 12.6667 3.4375Z"
            stroke="#1C274C"
            stroke-width="0.75"
          />
        </svg>
      ),
    },
  ];

  return (
    <div className="flex flex-col items-center justify-center bg-white pb-16 !mt-0">
      <div className="max-w-3xl w-full text-center">
        <h1 className="text-[2.8em] mb-4 font-raleway-700 font-extrabold">
          Welcome to <span className="text-[#27AE60]">Flicktest</span>
        </h1>
        <p className="text-[#282828] mb-8 font-poppins-400 font-normal ">
          Flicktest is a powerful tool designed to simplify and enhance the test
          management process for QA, Dev, Product, and DevOps teams. With
          Flicktest, managing test cases becomes as intuitive as using a
          spreadsheet, but with much more functionality and efficiency.
        </p>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 font-poppins">
          {cardsMap.map((item, index) => (
            <a href={`${item.link}`}>
              <button className="flex items-center justify-between group border-2 border-gray-200 rounded-lg p-4 shadow-sm hover:border-[#89AAFF] transition-colors font-medium text-[#1F1F1F] w-full">
                <div className="flex items-center justify-between">
                  {item.icon}
                  <span className="ml-2 font-semibold text-sm ">
                    {item.name}
                  </span>
                </div>
                <svg
                  width="13"
                  height="13"
                  viewBox="0 0 13 13"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    className="group-hover:stroke-[#316BFF] stroke-[#898187]"
                    d="M5.88889 8.94444L8.33333 6.5M8.33333 6.5L5.88889 4.05556M8.33333 6.5H1M1.92617 9.55556C2.91282 11.0296 4.59308 12 6.5 12C9.53759 12 12 9.53759 12 6.5C12 3.46244 9.53759 1 6.5 1C4.59308 1 2.91282 1.97046 1.92617 3.44444"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              </button>
            </a>
          ))}
        </div>
      </div>
    </div>
  );
}
